import React from "react";
import { Parser } from "json2csv";

const AutoCSVExportButton = ({ data, file_name }) => {
  const downloadBlob = (blob) => {
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);

    link.setAttribute("href", url);
    link.setAttribute("download", file_name);
    link.style.position = "absolute";
    link.style.visibility = "hidden";

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  };

  const exportCSV = (auto) => {
    try {
      const parser = new Parser();
      const contents = parser.parse(data);
      const blob = new Blob([contents], { type: "text/csv;charset=utf-8;" });

      downloadBlob(blob);

      if (auto) {
        window.history.back(); 
      }
    } catch (error) {
      console.error(error);
    }
  };

  exportCSV(true);

  return (
    <button id="export-csv" className="secondary-btn" onClick={exportCSV}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
        <path d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
      </svg>
    </button>
  );
};

export default AutoCSVExportButton;
